import { Link } from 'react-router-dom'
import { Form, InputNumber, Switch, Typography } from 'antd'
import { QaBlock } from './qaSettingsFormBlocks'

type Props = {
  disabled?: boolean
}

/** 嵌入问答设置主 Form，字段随页底「保存问答设置」一并提交。 */
export default function ContextualIndexPanel({ disabled = false }: Props) {
  const form = Form.useFormInstance()
  const enabled = Form.useWatch('contextual_index_enabled', form) ?? true

  return (
    <QaBlock
      title="索引语境增强"
      desc="索引阶段为切片生成 Contextual 前缀，写入 ES 的 search_content 与向量，提升 RAG 召回。"
    >
      <Typography.Paragraph type="secondary" style={{ marginBottom: 16 }}>
        关闭可显著加快全量索引且不再调用对话 API。前缀生成提示词在{' '}
        <Link to="/manage/agents">智能体 → 索引语境增强</Link> 配置；切片策略见{' '}
        <Link to="/manage/settings">知识加工 → 切片管理</Link>。
      </Typography.Paragraph>
      <Form.Item name="contextual_index_enabled" label="索引时生成语境前缀" valuePropName="checked">
        <Switch checkedChildren="开启" unCheckedChildren="关闭" disabled={disabled} />
      </Form.Item>
      <Form.Item
        name="contextual_index_max_chunks"
        label="每文档最多处理切片数"
        extra="仅对前 N 个子切片调用对话模型；0 表示不生成前缀。"
      >
        <InputNumber min={0} max={50} style={{ width: '100%' }} disabled={disabled || !enabled} />
      </Form.Item>
      <Form.Item
        name="contextual_index_delay_ms"
        label="切片间隔（毫秒）"
        extra="相邻两次前缀请求之间的等待，用于降低网关 429 限流风险。"
      >
        <InputNumber
          min={0}
          max={5000}
          step={50}
          style={{ width: '100%' }}
          disabled={disabled || !enabled}
        />
      </Form.Item>
    </QaBlock>
  )
}
